export default __webpack_public_path__ + "static/media/icon-annual-leave-am.d4e06a75.svg";